module.exports = __webpack_public_path__ + "media/images/MB-c8c3255708fb6343ef7a621f31ece11a.png";